<template>
   <main-block> 
        <main-title class="page__title_center page__title_between">
            Favorites page
            <button 
                class="main-btn main-btn_ml"
                v-if="favorites != null && favorites.length > 0"
                @click="clear"
            >
            clear all</button>
        </main-title>
 
        <div class="compare" v-if="favorites">   
            <template  v-if="favorites.length > 0">
                <!-- COMPARE LIST START -->
                <main-list
                    :comments="false"
                    :compare="false"
                    :data="favorites"  
                    :allowDifferent="false" 
                />
                <!-- COMPARE LIST END -->
            </template> 
            <template v-else>
                <div>
                    <router-link class="main-btn main-btn_mt" to='/history'>Add a first one</router-link>
                </div> 
            </template> 
        </div>
    </main-block>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import mainList from '@/components/lists/main/ListItem';

export default {
    components: {
        mainList
    },
    computed: {
        ...mapGetters({
            favorites: 'favorites/favorites'
        })
    },
    methods: {
        ...mapActions({
            get: 'favorites/get',
            clear: 'favorites/clear'
        })
    },
    async created() {
        await this.get();
    }
}
</script> 